// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';

// Service
import { WebsocketService } from './websocket.service';
import { Subject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
@Injectable({
  providedIn: 'root'
})
export class BTGChallengePromotionHttpService {

  static phase1Res: null;
  
  btgPhase1ResultIncoming = new Subject();
  updateSlotSessionIncoming = new Subject();
  messages$ = new Subject<any[]>();


  constructor(
    public dialog: MatDialog,
    private websocketService: WebsocketService,
    private http: HttpClient
  ) {}

  async btgChallengePromoInit(memberAccountId: number) {
    this.btgChallengePromoWebsocket(memberAccountId);
  }

  async updateSlotSessionInit() {
    this.updateSlotSessionWebsocket();
  }

  private btgChallengePromoWebsocket(memberAccountId: number) {
    this.websocketService
      .getChannel('btg-challenge-promo-channel.' + memberAccountId)
      .listen(`.BTGChallengePromotionEvent`, (data) => {
        if (data) {
          BTGChallengePromotionHttpService.phase1Res = data;
        } 
        
        this.btgPhase1ResultIncoming.next();
      });
  }

  private updateSlotSessionWebsocket() {
    this.websocketService
      .getChannel('update-slot-session-channel')
      .listen(`.UpdateSlotSessionEvent`, (data) => {
        if (data) {
          sessionStorage.removeItem('slotSession');
        } 
        
        this.updateSlotSessionIncoming.next();
      });
  }

   getActiveBTGChallengeRes(): Observable<any> {
    return this.http.get<ApiResponse>(`/promotion/activebtgchallengeresult`).pipe(
      map(res => res.data)
    );
  }

  updateBTGChallengeDialogSeen(data: any): Observable<any>{
    return this.http.put<ApiResponse>(`/promotion/updateppchallengeseen`, data).pipe(
      map(res => res.data)
    );
  }
}
